<template>
    <v-dialog v-model="objTasa.abrirDialogo" :max-width="tamModal" :fullscreen="$root.isTouch"
        :scrollable="$root.isTouch == false" persistent>
        <v-card>
            <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="objTasa.titulo"></span>
            </v-card-title>
            <v-card-text>
                <v-container fluid grid-list-sm>
                    <v-form ref="form_plantilla_tasas">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Aseguradora *" color="textbox"
                                    v-model="objPlantilla.idAseguradora" :items="listGeneral.listaAseguradoras"
                                    item-text="aseguradora" item-value="idAseguradora" :rules="requeridoRegla"
                                    @change="onListarSeguros" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Seguro *" color="textbox" v-model="objPlantilla.idSeguro"
                                    :items="listGeneral.listaSeguros" item-text="seguro" item-value="idSeguro"
                                    :rules="requeridoRegla" @change="onListarProductos" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Producto *" color="textbox" v-model="objPlantilla.idProducto"
                                    :items="listGeneral.listaProductos" item-text="nombre_producto"
                                    item-value="id_producto" :rules="requeridoRegla"
                                    @change="onListarProductosCobertura" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Cobertura *" color="textbox" v-model="objPlantilla.idCobertura"
                                    :items="listGeneral.listaCoberturas" item-text="cobertura" item-value="idCobertura"
                                    :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" class="text-right">
                                <v-btn rounded color="danger" class="mr-1" @click="reset">Salir</v-btn>
                                <v-btn rounded dark color="primary" @click="onClonar">Generar Copia de Plantilla</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalPlantillaTasaComponent',
        inject:['cerrarModalPlantilla'],
        props: {
            listaAseguradoras:{
                type: Array,
                default: []
            },
            objTasa:{
                type: Object,
                default: {}
            },
            parametros:{
                type: Object,
                default:{}
            }
        },
        data() {
            return {
                objPlantilla: {},
                listGeneral: {
                    listaAseguradoras: [],
                    listaSeguros: [],
                    listaProductos: [],
                    listaCoberturas: []
                }
            }
        },
        watch: {
            objTasa: {
                handler(val) {
                    this.objPlantilla = {};
                    if (val.abrirDialogo) {
                        this.listGeneral.listaAseguradoras = _.clone(this.listaAseguradoras);
                        this.objPlantilla.idAseguradora = this.listGeneral.listaAseguradoras[0].idAseguradora;
                        this.onListarSeguros('L');
                    }
                },
                deep: true
            }
        },
        methods:{
            onListar(ruta,objeto,lista){
                return axios.post(`${BASE_URI}${ruta}`,objeto)
                            .then((r) => {
                                if (r.status != 200) throw mensajeEstandar.errorPeticion;
                                if (_.get(r,['data','existeError'],true)) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                if (_.size(_.get(r,['data','data'],[]))>0){
                                    if (!_.isNull(lista)) 
                                        this.$set(this.listGeneral,lista,r.data.data);
                                }else
                                    mensajesAlerta(r.data.mensaje, 'I');
                                    
                                return r;
                            })
                            .catch((e)=>{
                                return e;
                            })
            },
            onListarSeguros(e){
                if(!_.isUndefined(e)){
                    this.getData(false,['idPoliza','idSeguro','idProducto','idCobertura','listaSeguros','listaProductos','listaCoberturas'],this.objPlantilla);
                    var objeto = _.merge({},this.getData(true,['idAseguradora','idEstado'],this.objPlantilla),{opcion: 'L_SEGURO'});

                    this.onListar('administrador/producto/listar',objeto,'listaSeguros')
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        })
                        .catch((ex) => { 
                            mensajesAlerta(ex,'E'); 
                        });
                }
            },
            onListarProductos(e){
                if(!_.isUndefined(e)){
                    this.getData(false,['idPoliza','idProducto','idCobertura','listaProductos','listaCoberturas'],this.objPlantilla);
                    var objeto = _.merge({},this.getData(true,['idAseguradora','idSeguro','idEstado'],this.objPlantilla),{opcion: 'LISTARCOMBO'});

                    this.onListar('administrador/producto/listar',objeto,'listaProductos')
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        })
                        .catch((ex) => { 
                            mensajesAlerta(ex,'E'); 
                        });
                }
            },
            onListarProductosCobertura(e){ 
                if(!_.isUndefined(e)){
                    this.getData(false,['idPoliza','idCobertura','listaCoberturas'],this.objPlantilla);
                    var objeto = _.merge({},this.getData(true,['idAseguradora','idSeguro','idProducto','idEstado'],this.objPlantilla),{opcion: 'L_NRO_POLIZA'});
                    
                    this.onListar('administrador/producto/listar',objeto,null)
                        .then((r) =>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(r.data.data) >0) {
                                this.$set(this.objPlantilla,'idPoliza',r.data.data[0].poliza);  
                                this.onListarCobertura('L');
                            }
                        }).catch((ex) => { 
                            mensajesAlerta(ex, 'E'); 
                        });
                                
                }    
            },
            onListarCobertura(e){
                if(!_.isUndefined(e)){
                    this.getData(false,['idCobertura','listaCoberturas'],this.objPlantilla);
                    var objeto = _.merge({},this.getData(true,['idProducto','idEstado'],this.objPlantilla),{opcion: 'COBERTURAS_X_PRODUCTO'});
                    this.onListar('administrador/planCobertura/listar',objeto,null)
                        .then((r) => {
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(r.data.data) > 0){
                                this.listGeneral.listaCoberturas = _.map(r.data.data, (v) => {
                                                                            v.idCobertura = v.id_cobertura;
                                                                            return v;
                                                                        });
                            }
                            return r;
                        })
                        .catch((ex) => { 
                            mensajesAlerta(ex, 'E'); 
                        });
                }
            },
            onClonar(event){
                if(!_.isUndefined(event)){
                    try {
                        var parentTasa = this.$parent.$parent;
                        if(!this.$refs.form_plantilla_tasas.validate()) throw mensajeEstandar.corregirInformacion;
                        if(_.toNumber(this.objPlantilla.idCobertura) != _.toNumber(parentTasa.objBusquedaTasa.idCobertura)) throw mensajeEstandar.coberturaNoIgual;
                            var objeto = {
                                            'idProducto'      : parentTasa.objBusquedaTasa.idProducto,
                                            "idProductoCopia" : this.objPlantilla.idProducto,
                                            "idCobertura"     : parentTasa.objBusquedaTasa.idCobertura,
                                            "idCoberturaCopia": this.objPlantilla.idCobertura,
                                            "idEstado"        : _.toString(this.parametros.idEstadoDefault)
                                        };

                            axios.post(`${BASE_URI}administrador/tasa-vehiculo/generar-plantilla`,objeto)
                                .then((r) => {
                                    if(r.status != 200) throw mensajeEstandar.errorPeticion;
                                    if(r.data.existeError) throw mensajeEstandar.errorPeticion;
                                    if(_.size(r.data.data) == 0) throw mensajeEstandar.errorPeticion;

                                        return parentTasa.onListarTodosRango('L');
                                })
                                .then((r) => {
                                    this.$set(parentTasa.objBusquedaTasa,'idRangoAnio' ,parentTasa.listGeneral.listAnio[0].id);
                                    this.$set(parentTasa.objBusquedaTasa,'idRangoEdad' ,parentTasa.listGeneral.listaEdad[0].id);
                                    this.$set(parentTasa.objBusquedaTasa,'idRangoValor' ,parentTasa.listGeneral.listaValor[0].id);
                                    this.$set(parentTasa.objBusquedaTasa,'idTipoVehiculo' ,parentTasa.listGeneral.listaTipoVehiculo[0].value);
                                    this.$set(parentTasa.objBusquedaTasa,'listaSexos' ,parentTasa.listGeneral.listaTipoVehiculo[0].idGenero);
                                    this.$set(parentTasa.objPlantilla,'abrirDialogo',false);                                
                                    return parentTasa.onListarTasas();
                                })
                                .then((r) => {
                                    mensajeAlertaTiempo('Se realizo la copia de la plantila con exito','S');
                                })
                                .catch((e) => {
                                    mensajesAlerta(e,'E');
                                });
                    } catch (error) {
                        mensajesAlerta(error,'I');
                    }

                }
            },
            reset(){
                this.$refs.form_plantilla_tasas.resetValidation();
                this.cerrarModalPlantilla();
            },
            getData(opc,keys,objeto){
                var obj = {};
                _.forEach(keys, (v) => {
                    if (opc) 
                        _.set(obj,v,_.get(objeto,v,null));
                    else if(_.isArray(_.get(this.listGeneral,v,null)))
                        this.$set(this.listGeneral,v,[]);
                    else
                        this.$set(objeto,v,null);
                });

                return obj;
            },
        }
    }
</script>